import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";
export var RestClient = /*#__PURE__*/function () {
  function RestClient(baseUrl, shop, authToken, getNewAuthTokenFunction, customRequestHeaders) {
    _classCallCheck(this, RestClient);

    this.baseUrl = baseUrl;
    this.shop = shop;
    this.authToken = authToken;
    this.getNewAuthTokenFunction = getNewAuthTokenFunction;
    this.customRequestHeaders = customRequestHeaders;
  }

  _createClass(RestClient, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(endpoint) {
        var requestMethod, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestMethod = 'GET';
                _context.next = 3;
                return this.invokeRequest("".concat(this.baseUrl, "/").concat(endpoint), requestMethod);

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.json();

              case 6:
                return _context.abrupt("return", _context.sent);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(endpoint, data) {
        var requestMethod, body, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                requestMethod = 'PUT';
                body = JSON.stringify(data);
                _context2.next = 4;
                return this.invokeRequest("".concat(this.baseUrl, "/").concat(endpoint), requestMethod, body);

              case 4:
                response = _context2.sent;
                return _context2.abrupt("return", response);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function put(_x2, _x3) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "postData",
    value: function () {
      var _postData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(endpoint, data) {
        var requestMethod, body, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                requestMethod = 'POST';
                body = JSON.stringify(data);
                _context3.next = 4;
                return this.invokeRequest("".concat(this.baseUrl, "/").concat(endpoint), requestMethod, body);

              case 4:
                response = _context3.sent;
                _context3.next = 7;
                return response.json();

              case 7:
                return _context3.abrupt("return", _context3.sent);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function postData(_x4, _x5) {
        return _postData.apply(this, arguments);
      }

      return postData;
    }()
  }, {
    key: "invokeRequest",
    value: function () {
      var _invokeRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url, requestMethod) {
        var body,
            request,
            headerKey,
            headerValue,
            response,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                body = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : undefined;
                request = {
                  method: requestMethod,
                  mode: 'cors',
                  cache: 'no-cache',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'Shop-Context': "".concat(this.shop),
                    'Request-Id': this.newGuid()
                  },
                  redirect: 'follow',
                  referrerPolicy: 'no-referrer'
                }; // Add custom request headers specified during construction

                if (this.customRequestHeaders !== undefined) {
                  for (headerKey in this.customRequestHeaders) {
                    headerValue = this.customRequestHeaders[headerKey];
                    request.headers[headerKey] = headerValue;
                  }
                } // Add Bearer auth header specified during construction


                if (this.authToken !== undefined) {
                  request.headers['Authorization'] = "Bearer ".concat(this.authToken);
                } // Add body to request


                if (body !== undefined) {
                  request['body'] = body;
                } // Invoke request


                _context4.next = 7;
                return fetch(url, request);

              case 7:
                response = _context4.sent;

                if (!(response.status === 401 && this.getNewAuthTokenFunction !== undefined)) {
                  _context4.next = 17;
                  break;
                }

                _context4.next = 11;
                return this.getNewAuthTokenFunction();

              case 11:
                this.authToken = _context4.sent;
                request.headers['Authorization'] = "Bearer ".concat(this.authToken);
                request.headers['Request-Id'] = this.newGuid();
                _context4.next = 16;
                return fetch(url, request);

              case 16:
                response = _context4.sent;

              case 17:
                if (!(response.status >= 400)) {
                  _context4.next = 19;
                  break;
                }

                throw new Error("".concat(requestMethod, " request to ").concat(url, " failed with response: ").concat(response.status, " - ").concat(response.statusText));

              case 19:
                return _context4.abrupt("return", response);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function invokeRequest(_x6, _x7) {
        return _invokeRequest.apply(this, arguments);
      }

      return invokeRequest;
    }()
  }, {
    key: "newGuid",
    value: function newGuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0; // eslint-disable-line no-bitwise

        var v = c == 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line no-bitwise, eqeqeq

        return v.toString(16);
      });
    }
  }]);

  return RestClient;
}();